export const MISSION_ATTEMPT_END_REASONS = {
  IN_PROGRESS: 'in_progress',
  SETTINGS_EXIT: 'settings_exit',
  BROWSER_REFRESH: 'browser_refresh',
  TAB_OR_WINDOW_CLOSE: 'tab_or_window_close',
  IN_APP_NAVIGATION: 'in_app_navigation',
  CONNECTION_LOST: 'connection_lost',
  UNKNOWN_END: 'unknown_end',
  END_WRITE_FAILED: 'end_write_failed',
  PAGE_UNLOAD: 'page_unload'
}

export const MISSION_ATTEMPT_SESSION_KEY = 'digipalz_mission_attempt_session'
export const MISSION_ATTEMPT_EXIT_REASON_KEY =
  'digipalz_mission_attempt_exit_reason'
export const MISSION_ATTEMPT_PENDING_END_KEY =
  'digipalz_mission_attempt_pending_end'

export const MISSION_ATTEMPT_END_REASON_PRIORITY = {
  [MISSION_ATTEMPT_END_REASONS.IN_PROGRESS]: 0,
  [MISSION_ATTEMPT_END_REASONS.PAGE_UNLOAD]: 1,
  [MISSION_ATTEMPT_END_REASONS.UNKNOWN_END]: 2,
  [MISSION_ATTEMPT_END_REASONS.END_WRITE_FAILED]: 3,
  [MISSION_ATTEMPT_END_REASONS.TAB_OR_WINDOW_CLOSE]: 4,
  [MISSION_ATTEMPT_END_REASONS.IN_APP_NAVIGATION]: 5,
  [MISSION_ATTEMPT_END_REASONS.CONNECTION_LOST]: 6,
  [MISSION_ATTEMPT_END_REASONS.BROWSER_REFRESH]: 7,
  [MISSION_ATTEMPT_END_REASONS.SETTINGS_EXIT]: 8
}
